import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class PermissionService {
  static accesslevelCreate = async (access_level) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/access-level/create",
        data: {
          access_level: access_level,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;
      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static accesslevelDetails = async (rowsPerPage, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/access-level/search",
        data: {
          filter: [{ status: "1" }],
          sort: "DESC",
          limit: 100,
          skip: page * rowsPerPage,
        },
      });

      let permissionDetail = response.data.data.results;
      return permissionDetail;
    } catch (err) {
      throw err;
    }
  };

  static accesslevelSearchDetails = async (role, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/access-level/search",
        data: {
          filter: [{ access_level: role }],
          sort: "DESC",
          limit: 100,
          skip: 0,
        },
      });

      let permissionDetail = response.data.data.results;
      return permissionDetail;
    } catch (err) {
      throw err;
    }
  };

  static accesslevelDelete = async (accesslevelID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/access-level/delete/" + accesslevelID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static accessmodulesDetails = async (token) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/access-modules/search",
        data: {
          filter: [{ status: "1" }],
          sort: "DESC",
          limit: 100,
          skip: 0,
        },
      });

      let accessmodulesDetail = response.data.data.results;
      return accessmodulesDetail;
    } catch (err) {
      throw err;
    }
  };

  static userpermissionCreate = async (
    access_id,
    access_module_id,

    permission_view,
    permission_add,
    permission_edit,
    permission_delete
  ) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/user-permissions/create",
        data: {
          access_id: access_id,
          access_module_id: access_module_id,

          permission_view: permission_view,
          permission_add: permission_add,
          permission_edit: permission_edit,
          permission_delete: permission_delete,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static userpermissionDetails = async (accesslevelid) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/user-permissions/search",
        data: {
          filter: [{ accessLevelId: accesslevelid }],
          sort: "DESC",
          limit: 100,
          skip: 0,
        },
      });

      let userpermissionDetail = response.data.data.results;
      return userpermissionDetail;
    } catch (err) {
      throw err;
    }
  };
}
